import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MapPin, Phone, Mail, Clock, Users, Microscope, GraduationCap, Building } from 'lucide-react';
export function Contact() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1343" data-mp="1qna81wff5arx">
      <Header data-id="element-1344" data-mp="1lrbdfr3hywj2" />
      <main className="flex-grow" data-id="element-1345" data-mp="1lrl3tfsgf5pa">
        {/* Hero Section */}
        <section className="relative w-full bg-navy-50" data-id="element-1346" data-mp="y05x7atna288">
          <div className="absolute inset-0 overflow-hidden" data-id="element-1347" data-mp="xyl47pmzarch">
            <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
            backgroundBlendMode: 'overlay'
          }} data-id="element-1348" data-mp="t2nljco8t8wj" />
            <div className="absolute inset-0 bg-gradient-to-r from-teal-600/20 to-navy-600/20" data-id="element-1349" data-mp="aalduqtkx2yf" />
          </div>
          <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-1350" data-mp="15f6sa825t9x1">
            <div className="max-w-3xl" data-id="element-1351" data-mp="19fphrvgky3w2">
              <h1 className="text-3xl md:text-5xl font-bold text-navy-800 mb-4" data-id="element-1352" data-mp="1e7qsve20hoki">
                Contact Us
              </h1>
              <div className="w-20 h-1 bg-teal-600 mb-6" data-id="element-1353" data-mp="1j7d97wd4zkxj"></div>
              <p className="text-lg md:text-xl text-navy-700 mb-8" data-id="element-1354" data-mp="1j8oa9of76eky">
                Have questions about our research, collaboration opportunities,
                or how to get involved? We'd love to hear from you.
              </p>
            </div>
          </div>
        </section>
        {/* Contact Information */}
        <section className="py-16 bg-white" data-id="element-1355" data-mp="10g2ipgbbpa66">
          <div className="container mx-auto px-4" data-id="element-1356" data-mp="10h5b5soanko7">
            <div className="grid md:grid-cols-2 gap-12" data-id="element-1357" data-mp="26woadeyefhc7">
              <div data-id="element-1358" data-mp="26w65jtxo7uso">
                <h2 className="text-2xl font-bold text-navy-800 mb-6" data-id="element-1359" data-mp="26ysbjp4wy28s">
                  Get in Touch
                </h2>
                <div className="space-y-6" data-id="element-1360" data-mp="1m73lpq9mh8a7">
                  <div className="flex items-start" data-id="element-1361" data-mp="1m5sfzkwm9qgg">
                    <div className="bg-teal-100 p-3 rounded-full mr-4" data-id="element-1362" data-mp="1h8isiassfov9">
                      <MapPin className="text-teal-600" size={20} data-id="element-1363" data-mp="1hamwesqosnvj" />
                    </div>
                    <div data-id="element-1364" data-mp="1w3gmt97hyoez">
                      <h3 className="font-bold text-navy-800 mb-1" data-id="element-1365" data-mp="1r6pzc0td4qjj">
                        Our Location
                      </h3>
                      <p className="text-navy-600" data-id="element-1366" data-mp="13hx98kzf9cwu">
                        California Institute for Microbiome Research
                        <br data-id="element-1367" data-mp="yjm0kdkv58g7" />
                        123 Science Way
                        <br data-id="element-1368" data-mp="1d7ql7n3h7u1m" />
                        San Francisco, CA 94107
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1369" data-mp="18e46lpdr5g36">
                    <div className="bg-teal-100 p-3 rounded-full mr-4" data-id="element-1370" data-mp="kpcndni5482j">
                      <Phone className="text-teal-600" size={20} data-id="element-1371" data-mp="frt6efu25h6w" />
                    </div>
                    <div data-id="element-1372" data-mp="2rewnvoasa5x4">
                      <h3 className="font-bold text-navy-800 mb-1" data-id="element-1373" data-mp="2rdlm1u0wf88n">Phone</h3>
                      <p className="text-navy-600" data-id="element-1374" data-mp="2w5v7oxuzdm54">
                        Main: (415) 555-0123
                        <br data-id="element-1375" data-mp="2hgz2r9o80p8q" />
                        Research Department: (415) 555-0124
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1376" data-mp="2mdh5k3zzqdif">
                    <div className="bg-teal-100 p-3 rounded-full mr-4" data-id="element-1377" data-mp="3a4ut7wn75kx2">
                      <Mail className="text-teal-600" size={20} data-id="element-1378" data-mp="3f3z5wx9by0s5" />
                    </div>
                    <div data-id="element-1379" data-mp="314g8aye5a7u3">
                      <h3 className="font-bold text-navy-800 mb-1" data-id="element-1380" data-mp="3157u5hhxwr76">Email</h3>
                      <p className="text-navy-600" data-id="element-1381" data-mp="355rqiiuovqs9">
                        General Inquiries:{' '}
                        <a href="mailto:info@calmir.org" className="text-teal-600 hover:underline" data-id="element-1382" data-mp="1ppj6sp0rxq5u">
                          info@calmir.org
                        </a>
                        <br data-id="element-1383" data-mp="29zlq5v0vyun0" />
                        Research Collaboration:{' '}
                        <a href="mailto:research@calmir.org" className="text-teal-600 hover:underline" data-id="element-1384" data-mp="2569e0kde8gb5">
                          research@calmir.org
                        </a>
                        <br data-id="element-1385" data-mp="2swvarfhy6e5u" />
                        Media Requests:{' '}
                        <a href="mailto:media@calmir.org" className="text-teal-600 hover:underline" data-id="element-1386" data-mp="2sw3owwe5jusr">
                          media@calmir.org
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1387" data-mp="17jk65tw0f9hd">
                    <div className="bg-teal-100 p-3 rounded-full mr-4" data-id="element-1388" data-mp="17kbpa58f7eqr">
                      <Clock className="text-teal-600" size={20} data-id="element-1389" data-mp="13hfc4u1ngau7" />
                    </div>
                    <div data-id="element-1390" data-mp="3f5u04a37glf8">
                      <h3 className="font-bold text-navy-800 mb-1" data-id="element-1391" data-mp="3f6ll6qz6f0r9">Hours</h3>
                      <p className="text-navy-600" data-id="element-1392" data-mp="3j6du54shf8x5">
                        Monday - Friday: 9:00 AM - 5:00 PM
                        <br data-id="element-1393" data-mp="3o4xl5jlxnawd" />
                        Saturday - Sunday: Closed
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-10" data-id="element-1394" data-mp="1qnvz8a6hyuj">
                  <h2 className="text-2xl font-bold text-navy-800 mb-6" data-id="element-1395" data-mp="1pmd4hmx8829">
                    Connect With Us
                  </h2>
                  <div className="flex space-x-4" data-id="element-1396" data-mp="6rbnrw68ejpt">
                    <a href="https://twitter.com/calmir" target="_blank" rel="noopener noreferrer" className="bg-navy-100 hover:bg-navy-200 p-3 rounded-full transition-colors duration-200" aria-label="Twitter" data-id="element-1397" data-mp="as5cusveu4ka">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-navy-700" data-id="element-1398" data-mp="2hjmnqe0ntosb">
                        <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" data-id="element-1399" data-mp="7jt9usiry7un"></path>
                      </svg>
                    </a>
                    <a href="https://linkedin.com/company/calmir" target="_blank" rel="noopener noreferrer" className="bg-navy-100 hover:bg-navy-200 p-3 rounded-full transition-colors duration-200" aria-label="LinkedIn" data-id="element-1400" data-mp="ccmhpp9jhway">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-navy-700" data-id="element-1401" data-mp="14zniuj6jwdtu">
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-1402" data-mp="r04l8kbd8kvs"></path>
                        <rect x="2" y="9" width="4" height="12" data-id="element-1403" data-mp="cc9rd0lmgah4"></rect>
                        <circle cx="4" cy="4" r="2" data-id="element-1404" data-mp="hal1zdjqqp0e"></circle>
                      </svg>
                    </a>
                    <a href="https://facebook.com/calmir" target="_blank" rel="noopener noreferrer" className="bg-navy-100 hover:bg-navy-200 p-3 rounded-full transition-colors duration-200" aria-label="Facebook" data-id="element-1405" data-mp="3b1y4wxypztw">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-navy-700" data-id="element-1406" data-mp="dsovmujnpvkw">
                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-1407" data-mp="3r58rfuhyxymb"></path>
                      </svg>
                    </a>
                    <a href="https://instagram.com/calmir" target="_blank" rel="noopener noreferrer" className="bg-navy-100 hover:bg-navy-200 p-3 rounded-full transition-colors duration-200" aria-label="Instagram" data-id="element-1408" data-mp="3h846fxzv0973">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-navy-700" data-id="element-1409" data-mp="21qg9dintr4g7">
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-1410" data-mp="1iy597wkk1kls"></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-1411" data-mp="v8t3j6ofruo8"></path>
                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-1412" data-mp="owsqm0ow6r5s"></line>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div data-id="element-1413" data-mp="ywtelzxphvgb">
                <h2 className="text-2xl font-bold text-navy-800 mb-6" data-id="element-1414" data-mp="ywb8mbl8s2v7">
                  Send Us a Message
                </h2>
                <form className="space-y-6" data-id="element-1415" data-mp="13sigi9x77ofs">
                  <div className="grid md:grid-cols-2 gap-6" data-id="element-1416" data-mp="685onr20ihwf">
                    <div data-id="element-1417" data-mp="b677qbzfuh7w">
                      <label htmlFor="name" className="block text-sm font-medium text-navy-700 mb-1" data-id="element-1418" data-mp="b5e9jzejp01d">
                        Full Name
                      </label>
                      <input type="text" id="name" name="name" className="w-full px-4 py-2 border border-navy-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="Your name" required data-id="element-1419" data-mp="kxblj8ddnw15" />
                    </div>
                    <div data-id="element-1420" data-mp="21m9ojwdyprm4">
                      <label htmlFor="email" className="block text-sm font-medium text-navy-700 mb-1" data-id="element-1421" data-mp="1wp157sh2vhja">
                        Email Address
                      </label>
                      <input type="email" id="email" name="email" className="w-full px-4 py-2 border border-navy-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="Your email" required data-id="element-1422" data-mp="1mrwtynort6h9" />
                    </div>
                  </div>
                  <div data-id="element-1423" data-mp="142gf0vcc9bhb">
                    <label htmlFor="subject" className="block text-sm font-medium text-navy-700 mb-1" data-id="element-1424" data-mp="z1srijnbjcru">
                      Subject
                    </label>
                    <input type="text" id="subject" name="subject" className="w-full px-4 py-2 border border-navy-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="Subject of your message" required data-id="element-1425" data-mp="ue1bh6bmy2xl" />
                  </div>
                  <div data-id="element-1426" data-mp="1d26e2agk3hut">
                    <label htmlFor="department" className="block text-sm font-medium text-navy-700 mb-1" data-id="element-1427" data-mp="1d5lrl8ul0iu4">
                      Department
                    </label>
                    <select id="department" name="department" className="w-full px-4 py-2 border border-navy-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent" required data-id="element-1428" data-mp="1r3iqwd0f73ch">
                      <option value="" data-id="element-1429" data-mp="3bluny3invz9q">Select a department</option>
                      <option value="general" data-id="element-1430" data-mp="3bj8e1x8at7oc">General Inquiries</option>
                      <option value="research" data-id="element-1431" data-mp="3q9o35n3u4zrs">Research Collaboration</option>
                      <option value="media" data-id="element-1432" data-mp="3lc5rvq2ci8gm">Media & Press</option>
                      <option value="careers" data-id="element-1433" data-mp="2xljxv2p6eopm">Careers & Opportunities</option>
                      <option value="support" data-id="element-1434" data-mp="2xnmlxh6rq7rp">Support & Donations</option>
                    </select>
                  </div>
                  <div data-id="element-1435" data-mp="37jg5vlmth3ji">
                    <label htmlFor="message" className="block text-sm font-medium text-navy-700 mb-1" data-id="element-1436" data-mp="37jzl2ul31dtu">
                      Message
                    </label>
                    <textarea id="message" name="message" rows={5} className="w-full px-4 py-2 border border-navy-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="Your message" required data-id="element-1437" data-mp="mrxjzs7l8via"></textarea>
                  </div>
                  <div className="flex items-start" data-id="element-1438" data-mp="2wi1l5xb0yr9o">
                    <input id="privacy" name="privacy" type="checkbox" className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-navy-300 rounded mt-1" required data-id="element-1439" data-mp="31iplj9l58kgk" />
                    <label htmlFor="privacy" className="ml-2 block text-sm text-navy-600" data-id="element-1440" data-mp="3g6txzvtlrzqw">
                      I agree to the{' '}
                      <a href="/privacy-policy" className="text-teal-600 hover:underline" data-id="element-1441" data-mp="3p8juvh697qw2">
                        privacy policy
                      </a>{' '}
                      and consent to being contacted regarding my inquiry.
                    </label>
                  </div>
                  <div data-id="element-1442" data-mp="38no9mttrvtw">
                    <button type="submit" className="w-full px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors duration-200 shadow-sm" data-id="element-1443" data-mp="3ucm1wqab5u0s">
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        {/* Map Section */}
        <section className="py-16 bg-navy-50" data-id="element-1444" data-mp="h5anjw992y2z">
          <div className="container mx-auto px-4" data-id="element-1445" data-mp="h3zi7s05pi9r">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1446" data-mp="d3z3s7d2572p">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-1447" data-mp="19memx5jtn9uw">
                Visit Our Location
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-1448" data-mp="14uvg96v7h9pg"></div>
              <p className="text-navy-600" data-id="element-1449" data-mp="2z421w8e61hbb">
                Our state-of-the-art research facility is located in the heart
                of San Francisco's biotech district.
              </p>
            </div>
            <div className="bg-navy-200 rounded-lg overflow-hidden h-96" data-id="element-1450" data-mp="2peihgyat1fec">
              {/* This would be replaced with an actual map component in a real implementation */}
              <div className="w-full h-full bg-navy-300 flex items-center justify-center" data-id="element-1451" data-mp="2gdaj6g8agek9">
                <div className="text-center" data-id="element-1452" data-mp="2gfn8xfkaft7v">
                  <MapPin className="text-teal-600 mx-auto mb-2" size={32} data-id="element-1453" data-mp="2ldf0g8h0tdbj" />
                  <p className="text-navy-700 font-medium" data-id="element-1454" data-mp="26fmn9myy510i">
                    Interactive Map Placeholder
                  </p>
                  <p className="text-navy-600 text-sm" data-id="element-1455" data-mp="2bez9c5hzu421">
                    123 Science Way, San Francisco, CA 94107
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Department Contacts */}
        <section className="py-16 bg-white" data-id="element-1456" data-mp="1u4luq49m5yvc">
          <div className="container mx-auto px-4" data-id="element-1457" data-mp="1u5eu2k68tm3g">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1458" data-mp="1p62ac8ao4v53">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-1459" data-mp="1p3pjf5mxnafw">
                Department Contacts
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-1460" data-mp="1z3yg0kku6xvt"></div>
              <p className="text-navy-600" data-id="element-1461" data-mp="1z1vizgl9o4hl">
                Connect with the specific department that can best address your
                needs.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1462" data-mp="28t89a3rf2mli">
              <div className="bg-navy-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-1463" data-mp="2mtsvl9wjj0jr">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-1464" data-mp="2hvhm50a5qs22">
                  <Microscope className="text-teal-600" size={24} data-id="element-1465" data-mp="sgb4jcwxfljz" />
                </div>
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-1466" data-mp="nhgmid6sa10x">
                  Research
                </h3>
                <p className="text-navy-600 mb-4" data-id="element-1467" data-mp="1mq23xj5hxw8">
                  For collaboration inquiries, study participation, or research
                  questions.
                </p>
                <p className="text-navy-700" data-id="element-1468" data-mp="be3z9ynmqlm7">
                  <a href="mailto:research@calmir.org" className="text-teal-600 hover:underline" data-id="element-1469" data-mp="bff2nxd5xrcs">
                    research@calmir.org
                  </a>
                  <br data-id="element-1470" data-mp="3jsmag98vaha1" />
                  (415) 555-0124
                </p>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-1471" data-mp="3os8ogkwis1jw">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-1472" data-mp="3tqs98hzdn7ao">
                  <Users className="text-teal-600" size={24} data-id="element-1473" data-mp="142jasb7jylss" />
                </div>
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-1474" data-mp="190ku8x8w4n4s">
                  Administration
                </h3>
                <p className="text-navy-600 mb-4" data-id="element-1475" data-mp="2thtzmdlzjcl2">
                  For administrative matters, operations, and general inquiries.
                </p>
                <p className="text-navy-700" data-id="element-1476" data-mp="2om4yi5ubhnmn">
                  <a href="mailto:admin@calmir.org" className="text-teal-600 hover:underline" data-id="element-1477" data-mp="2js0plh1hr5ix">
                    admin@calmir.org
                  </a>
                  <br data-id="element-1478" data-mp="29vnvwj5y4ro6" />
                  (415) 555-0125
                </p>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-1479" data-mp="25shubots3oo1">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-1480" data-mp="20uzldyfrh9g1">
                  <GraduationCap className="text-teal-600" size={24} data-id="element-1481" data-mp="1vwy0d7yrz01x" />
                </div>
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-1482" data-mp="3v7pdcamkk8ks">
                  Education
                </h3>
                <p className="text-navy-600 mb-4" data-id="element-1483" data-mp="3q71lxnufhpq1">
                  For educational programs, workshops, and training
                  opportunities.
                </p>
                <p className="text-navy-700" data-id="element-1484" data-mp="h01dxn54m1h3">
                  <a href="mailto:education@calmir.org" className="text-teal-600 hover:underline" data-id="element-1485" data-mp="c80222bvecrl">
                    education@calmir.org
                  </a>
                  <br data-id="element-1486" data-mp="37uxs11z3uhn" />
                  (415) 555-0126
                </p>
              </div>
              <div className="bg-navy-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300" data-id="element-1487" data-mp="3ud3a9vx4v4w8">
                <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-1488" data-mp="3pdqe2kkdglgz">
                  <Building className="text-teal-600" size={24} data-id="element-1489" data-mp="3kgi4h8dahprc" />
                </div>
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-1490" data-mp="1nnexv2sceyl4">
                  Partnerships
                </h3>
                <p className="text-navy-600 mb-4" data-id="element-1491" data-mp="1ipdeegr08x94">
                  For industry partnerships, sponsorships, and donation
                  inquiries.
                </p>
                <p className="text-navy-700" data-id="element-1492" data-mp="1v666bm38ruvx">
                  <a href="mailto:partnerships@calmir.org" className="text-teal-600 hover:underline" data-id="element-1493" data-mp="1v4v25l5vwl4a">
                    partnerships@calmir.org
                  </a>
                  <br data-id="element-1494" data-mp="18689rl266obw" />
                  (415) 555-0127
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-1495" data-mp="1c8bxp960zle2" />
    </div>;
}